import React from 'react';
import { IIconProps } from './utils';

export const Circle = ({
  color, fill = 'currentColor', size = 9, children, stroke, strokeWidth, ...rest
}: IIconProps) => {
  const sizeInt = typeof size === 'string' ? parseInt(size, 10) : size;
  const strokeWidthInt = typeof strokeWidth === 'string' ? parseInt(strokeWidth, 10) : strokeWidth;

  return (
    <svg
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      width={size}
      {...rest}
    >
      <circle
        cx={sizeInt / 2}
        cy={sizeInt / 2}
        fill={fill ?? color}
        r={(sizeInt / 2) - (strokeWidth ? strokeWidthInt / 2 : 0)}
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      {children}
    </svg>
  );
};
